import { Button as AntButton } from "antd";
import React from "react";

export const Button = (props: React.ComponentProps<typeof AntButton>) => {
  return (
    <>
      <AntButton
        type="primary"
        {...props}
        className={`noShadow font13 capitalize r7 ${props.className || ""}`}
      />
    </>
  );
};
